export default __webpack_public_path__ + "static/media/DIFC.e2e7c36a.png";